import script from './component-lib.esm52.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._b({
    staticClass: "icon-calendly",
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'Calendly'
  }, _vm.$attrs), false), [_c('path', {
    attrs: {
      "d": "M19.422 18.723c-.914.812-2.059 1.828-4.137 1.828h-1.242c-1.5 0-2.867-.547-3.844-1.54-.957-.964-1.48-2.288-1.48-3.726v-1.7c0-1.433.523-2.757 1.48-3.726.977-.988 2.344-1.535 3.844-1.535h1.242c2.078 0 3.223 1.012 4.137 1.828.953.836 1.773 1.57 3.965 1.57.336 0 .668-.027.996-.077l-.008-.02a7.578 7.578 0 00-.457-.95l-1.465-2.534a7.526 7.526 0 00-6.512-3.758h-2.93A7.521 7.521 0 006.5 8.14l-1.465 2.535a7.536 7.536 0 000 7.52L6.5 20.73a7.517 7.517 0 006.512 3.762h2.93a7.522 7.522 0 006.511-3.762l1.465-2.53c.172-.302.328-.618.457-.946l.008-.02a6.049 6.049 0 00-.996-.082c-2.192 0-3.012.73-3.965 1.57",
      "fill": "#006bff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15.285 9.863h-1.242c-2.285 0-3.785 1.633-3.785 3.723v1.7c0 2.089 1.5 3.722 3.785 3.722h1.242c3.332 0 3.07-3.395 8.102-3.395.476 0 .953.043 1.422.13a7.528 7.528 0 000-2.614c-.47.09-.946.133-1.422.133-5.032 0-4.77-3.399-8.102-3.399",
      "fill": "#006bff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.7 16.984a7.044 7.044 0 00-2.891-1.242v.028c-.09.5-.23.988-.418 1.46.863.133 1.68.473 2.386.985a12.875 12.875 0 01-14.234 8.957 12.88 12.88 0 010-25.473 12.878 12.878 0 0114.227 8.938c0 .008.007.015.007.023a5.492 5.492 0 01-2.386.98c.187.473.328.965.418 1.465v.024a7.037 7.037 0 002.89-1.238c.824-.61.664-1.301.54-1.707a14.438 14.438 0 100 8.508c.124-.41.284-1.098-.54-1.708",
      "fill": "#006bff"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24.383 11.64c-.328.055-.66.087-.996.087-2.192 0-3.012-.73-3.961-1.575-.918-.812-2.063-1.824-4.14-1.824h-1.243c-1.5 0-2.867.547-3.844 1.535-.957.969-1.48 2.293-1.48 3.727v1.7c0 1.437.523 2.76 1.48 3.726.977.992 2.344 1.535 3.844 1.535h1.242c2.078 0 3.223-1.012 4.14-1.824.95-.84 1.77-1.57 3.962-1.57.336 0 .668.027.996.077a7.31 7.31 0 00.422-1.464v-.024a7.89 7.89 0 00-1.422-.129c-5.031 0-4.77 3.395-8.102 3.395H14.04c-2.285 0-3.785-1.633-3.785-3.723v-1.703c0-2.09 1.5-3.723 3.785-3.723h1.242c3.332 0 3.07 3.399 8.102 3.399.476 0 .953-.043 1.422-.133v-.024c-.09-.5-.23-.992-.422-1.464",
      "fill": "#0ae8f0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M24.383 11.64c-.328.055-.66.087-.996.087-2.192 0-3.012-.73-3.961-1.575-.918-.812-2.063-1.824-4.14-1.824h-1.243c-1.5 0-2.867.547-3.844 1.535-.957.969-1.48 2.293-1.48 3.727v1.7c0 1.437.523 2.76 1.48 3.726.977.992 2.344 1.535 3.844 1.535h1.242c2.078 0 3.223-1.012 4.14-1.824.95-.84 1.77-1.57 3.962-1.57.336 0 .668.027.996.077a7.31 7.31 0 00.422-1.464v-.024a7.89 7.89 0 00-1.422-.129c-5.031 0-4.77 3.395-8.102 3.395H14.04c-2.285 0-3.785-1.633-3.785-3.723v-1.703c0-2.09 1.5-3.723 3.785-3.723h1.242c3.332 0 3.07 3.399 8.102 3.399.476 0 .953-.043 1.422-.133v-.024c-.09-.5-.23-.992-.422-1.464",
      "fill": "#0ae8f0"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var CalendlyIcon = __vue_component__;
export { CalendlyIcon as default };